/* @flow weak */
import BoxBody from 'components/BoxBody.jsx';
import Button from 'components/Button.jsx';
import CurrentUser from 'auth/CurrentUser';
import DialogContent from 'components/DialogContent.jsx';
import Form from 'components/Form.jsx';
import FormInput from 'components/FormInput.jsx';
import humanparser from 'humanparser';
import React from 'react';
import RequireUser from 'components/mixins/RequireUser';
import ToastActions from 'actions/ToastActions';
import UserActions from 'user/UserActions';


const SetupFullName = React.createClass({
  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    RequireUser,
  ],

  getInitialState() {
    return {
      enable: false,
    };
  },

  submit(attrs) {
    const human = humanparser.parseName(attrs['full_name']);
    const data = {
      first_name: human.firstName,
      last_name: human.lastName,
    };

    const onSuccess = () => {
      ToastActions.showSuccessToast('Saved!');
      this.context.router.push('/');
    };

    const onFailure = (error) => ToastActions.showAPIError(error);

    UserActions
      .update(data)
      .then(onSuccess, onFailure);
  },

  render() {
    const user = CurrentUser.getUser();
    let fullName = '';

    if (user.getFirstName() && user.getLastName()) {
      fullName = user.getFirstName() + ' ' + user.getLastName();
    } else {
      fullName = user.getFirstName() || user.getLastName() || '';
    }

    return (
      <DialogContent
        size="small"
        full
        className="SetupFullName"
        title={'What’s your name?'}>
        <BoxBody divided>
          <Form
            onValidSubmit={this.submit}
            onValid={() => this.setState({ enabled: true })}
            onInvalid={() => this.setState({ enabled: false })}>
            <div className="SetupFullName-First">
              <FormInput
                label="Full name"
                required
                name="full_name"
                showErrorOnPristine={false}
                value={fullName}
                placeholder="First and last name"
                validations={{ maxLength: 255 }}
                validationErrors={{
                  maxLength: 'Name should be shorter than 255 characters.',
                }}
              />
            </div>
            <Button
              disabled={!this.state.enabled}
              className="SetupFullName-Submit"
              type="submit"
              eventElementName="SetupFullName-Submit">
              Next
            </Button>
          </Form>
        </BoxBody>
      </DialogContent>
    );
  },
});

export default SetupFullName;



// WEBPACK FOOTER //
// ./src/setup/components/SetupFullName.jsx